import { render, staticRenderFns } from "./AppOffers.vue?vue&type=template&id=0c0c85fd&scoped=true&lang=pug"
import script from "./AppOffers.vue?vue&type=script&lang=js"
export * from "./AppOffers.vue?vue&type=script&lang=js"
import style0 from "./AppOffers.vue?vue&type=style&index=0&id=0c0c85fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0c85fd",
  null
  
)

export default component.exports